import { useAtom } from "jotai";
import { StartDateAtom, YearsAtom } from "./atoms";
import { useCallback } from "react";
import * as DateFns from "date-fns";

export function useGetDateFromYearDelta() {
  const [years] = useAtom(YearsAtom);
  const [startDate] = useAtom(StartDateAtom);
  return useCallback(
    yearDelta => {
      if (!Number.isFinite(yearDelta) || yearDelta < 0 || yearDelta > years) {
        return null;
      }
      return DateFns.addDays(startDate, yearDelta * 365);
    },
    [startDate, years]
  );
}
